import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { UtilComponent } from 'app/shared/common/utils/UtilComponent';
import { TenantService } from 'app/modules/manage/components/tenant/tenant.service';
import { tap } from 'rxjs';
import { ISelectOption } from 'app/modules/manage/components/create-user/create-user.service';
import { UntilDestroy } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
    selector: 'popup-user-tenant',
    templateUrl: './popup-user-tenant.html',
    encapsulation: ViewEncapsulation.None
})
export class PopUpUserTenant implements OnInit {

    public formGroup: FormGroup;
    public lstTenant: any = [];
    public currentTenantCode = '';
    @Input() set tenant(value: string) {
        this.currentTenantCode = value;
    };
    @Output() submitClicked = new EventEmitter();
    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<PopUpUserTenant>,
        private _utilComponent: UtilComponent,
        private _formBuilder: FormBuilder,
        public _service: TenantService,
        private _translocoService: TranslocoService) {
        this._loadData();
    }

    ngOnInit(): void {
        this._initForm();
    }


    public isValid(): boolean {
        let validForm: boolean = this._utilComponent.checkValidateForm(this.formGroup);
        return validForm;
    }

    public save(): void {
        if (this.formGroup?.invalid) {
            return;
        }
        this.submitClicked?.emit(this.formGroup?.get('tenantCode')?.value);
    }

    close(): void {
        this.matDialogRef.close();
    }

    private _initForm() {
        this.formGroup = this._formBuilder.group({
            tenantCode: ['', Validators.compose([Validators.required])]
        });
    }
    private _loadData() {
        this.lstTenant = [];
        this._service.getTenantsOfSuperUsers()?.pipe(tap(rs => {
            if (rs?.length > 0) {
                this.lstTenant = rs?.map(item => ({
                    code: item?.tenantCode,
                    name: item?.tenantName
                }));
            }
            this.formGroup?.get('tenantCode')?.setValue(this.currentTenantCode);
            this.formGroup?.updateValueAndValidity();
        }))?.subscribe();


    }
}